import makeStyles from '@mui/styles/makeStyles';
import React, {useEffect} from 'react';
import MatchingContentWrapper from "views/Matching/MatchingContentWrapper";
import {color, space} from "common/tokens";

// Same shell as the other redesigned pages — white ground, the shared container
// width, the shared padding rhythm. Matching is a single-column task, so its
// content sits in a reading column centred in that container.
const useStyles = makeStyles(theme => ({
  page: {
    background: color.SURFACE,
    minHeight: '100%',
    flex: 1,
  },
  container: {
    width: '100%',
    maxWidth: space.CONTAINER_MAX,
    margin: '0 auto',
    padding: '40px 32px 64px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '24px 16px 48px',
    },
  },
  column: {
    width: '100%',
    maxWidth: 780,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 28,
  },
}));

const ActiveMatching = props => {
  const classes = useStyles();
  const {getActiveMatches} = props;

  useEffect(() => {
    getActiveMatches()
  }, []);

  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <div className={classes.column}>
          <MatchingContentWrapper {...props}/>
        </div>
      </div>
    </div>
  )
};

export default ActiveMatching;
